import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaFacebook, FaYoutube, FaTiktok } from "react-icons/fa";

export default function Footer() {
  return (
    <footer style={styles.footer}>
      <p style={styles.text}>
        Réalisé avec ❤️ et passion par 
        <a 
          href="https://www.loven-soft.com" 
          target="_blank" 
          rel="noopener noreferrer" 
          style={styles.link}
        >
          LSD
        </a>
      </p>

      <div style={styles.legalLinks}>
        <Link to="/privacy" style={styles.legalLink}>
          Politique de confidentialité
        </Link>
        <Link to="/terms" style={styles.legalLink}>
          Conditions d'utilisation
        </Link>
      </div>

      {/* SOCIAL ICONS */}
      <div style={styles.socialContainer}>
        <span style={{ ...styles.icon, ...styles.iconDisabled }} aria-hidden="true">
          <FaTiktok size={22} />
        </span>
        <a href="https://www.instagram.com/goalfit2026?igsh=MWFjYTZ3bG9zamEwZg%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" style={styles.icon}><FaInstagram size={22} /></a>
        <a href="https://www.facebook.com/profile.php?id=61584761788641" target="_blank" rel="noopener noreferrer" style={styles.icon}><FaFacebook size={22} /></a>
        <span style={{ ...styles.icon, ...styles.iconDisabled }} aria-hidden="true">
          <FaYoutube size={22} />
        </span>
      </div>
    </footer>
  );
}

const styles = {
  footer: {
    textAlign: "center",
    paddingHorizontal: 30,
    opacity: 0.85,
    marginTop: 40,
    paddingBottom: 30,
  },
  text: {
    fontSize: 15,
    marginBottom: 10,
  },
  link: {
    color: "#005DFF",
    fontWeight: "bold",
    marginLeft: 6,
    textDecoration: "none",
  },
  socialContainer: {
    marginTop: 10,
    display: "flex",
    justifyContent: "center",
    gap: 18,
  },
  legalLinks: {
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: 18,
    marginBottom: 14,
  },
  legalLink: {
    color: "#c7d6ff",
    textDecoration: "none",
    fontSize: 14,
  },
  icon: {
    color: "#fff",
    opacity: 0.8,
    transition: "0.25s",
    textDecoration: "none",
  },
  iconDisabled: {
    opacity: 0.35,
    cursor: "default",
  },
};

// Hover animation (added via injected CSS)
const css = document.createElement("style");
css.innerHTML = `
  footer a:hover {
    opacity: 1 !important;
    transform: scale(1.15);
  }
`;
document.head.appendChild(css);
